webpackJsonp([1,2],Array(56).concat([
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
	HeadNav: __webpack_require__(157),
	FootNav: __webpack_require__(155),
	HeadNav2: __webpack_require__(159)
};

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPDATE_TITLE; });

var UPDATE_TITLE = 'UPDATE_TITLE';

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UPDATE_USERINFO; });

var UPDATE_USERINFO = 'UPDATE_USERINFO';

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(99)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(147),
  /* template */
  __webpack_require__(95),
  /* scopeId */
  "data-v-a896980e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__setting_js__ = __webpack_require__(168);




__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_2_axios___default.a);



__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].axios.defaults.baseURL = __WEBPACK_IMPORTED_MODULE_4__setting_js__["a" /* default */].gbs.host;

var ajax = function ajax(type, url, data, fn, errFn) {
	var _this = this;

	if (type === 'get') {
		var datas = {
			params: data
		};
	} else {
		var datas = data;
	}

	__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].axios[type](url, datas).then(function (res) {
		if (res.data[__WEBPACK_IMPORTED_MODULE_4__setting_js__["a" /* default */].gbs.api_key] === __WEBPACK_IMPORTED_MODULE_4__setting_js__["a" /* default */].gbs.api_value) {
			fn(res.data.data);
		} else {
			if (errFn) {
				errFn.call(_this, res.data);
			} else {
				__WEBPACK_IMPORTED_MODULE_4__setting_js__["a" /* default */].cbs.statusError.call(_this, res.data);
			}
		}
	}).catch(function (err) {
		if (errFn) {
			errFn.call(_this, err);
		} else {
			__WEBPACK_IMPORTED_MODULE_4__setting_js__["a" /* default */].cbs.requestError.call(_this, err);
		}
	});
};

var apis = {
	user: {
		login: function login(data, fn, errFn) {
			ajax.call(this, 'post', 'Login/login', data, fn, errFn);
		}
	}
};

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use({
	install: function install(Vue, options) {
		for (var m in apis) {
			if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(apis[m]) === 'object') {
				for (var f in apis[m]) {
					Vue.prototype['$$' + f] = apis[m][f];
				}
			}
		}
	}
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components___ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components___);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
	routes: [{
		path: '/',
		redirect: function redirect() {
			return 'home';
		}
	}, {
		path: '/home',
		name: '首页',
		component: __WEBPACK_IMPORTED_MODULE_2__components___["Modules"].Home
	}, {
		path: '/list',
		name: '列表',
		component: __WEBPACK_IMPORTED_MODULE_2__components___["Modules"].List
	}, {
		path: '/view',
		name: '详情',
		component: __WEBPACK_IMPORTED_MODULE_2__components___["Modules"].View
	}]
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__global___ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__userinfo___ = __webpack_require__(176);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
	modules: {
		global: __WEBPACK_IMPORTED_MODULE_2__global___["a" /* default */],
		user: __WEBPACK_IMPORTED_MODULE_3__userinfo___["a" /* default */]
	}
});

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(97)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(148),
  /* template */
  __webpack_require__(91),
  /* scopeId */
  "data-v-49a5f0e8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(98)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(94),
  /* scopeId */
  "data-v-8c0c10f8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(96)

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(150),
  /* template */
  __webpack_require__(90),
  /* scopeId */
  "data-v-3e05ac5c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(151),
  /* template */
  __webpack_require__(89),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(93),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(6)(
  /* script */
  __webpack_require__(153),
  /* template */
  __webpack_require__(92),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.username),
      expression: "data.username"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.data.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.password),
      expression: "data.password"
    }],
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.data.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.data.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登录")])])
},staticRenderFns: []}

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', [_c('span', [_vm._v("第二个头部")])])])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('footer', [_c('a', {
    attrs: {
      "href": "#home"
    }
  }, [_c('div', {
    staticClass: "nav"
  }, [_vm._v("首页")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#list"
    }
  }, [_c('div', {
    staticClass: "nav"
  }, [_vm._v("列表")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#view"
    }
  }, [_c('div', {
    staticClass: "nav"
  }, [_vm._v("详情")])])])])
}]}

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n\t详情\n")])
},staticRenderFns: []}

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n\t列表\n")])
},staticRenderFns: []}

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.$store.state.global.title)
    }
  }), _vm._v(" "), (_vm.$store.state.user.userinfo.username) ? _c('span', {
    staticClass: "logout",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("退出")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "userinfo",
    domProps: {
      "innerHTML": _vm._s(_vm.$store.state.user.userinfo.username || "登录")
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c(_vm.currentView, {
    tag: "component",
    attrs: {
      "keep-alive": ""
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('foot-nav')], 1)
},staticRenderFns: []}

/***/ }),
/* 96 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 97 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 98 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 99 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Common___ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Common____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Common___);



/* harmony default export */ __webpack_exports__["default"] = {
    name: 'app',
    components: {
        HeadNav: __WEBPACK_IMPORTED_MODULE_0__components_Common___["HeadNav"],
        FootNav: __WEBPACK_IMPORTED_MODULE_0__components_Common___["FootNav"],
        HeadNav2: __WEBPACK_IMPORTED_MODULE_0__components_Common___["HeadNav2"]
    },
    data: function data() {
        return {
            currentView: 'HeadNav'
        };
    },

    watch: {
        $route: function $route(to, from) {
            console.log(to.path);
            switch (to.path) {
                case '/view':
                    this.currentView = 'HeadNav2';
                    break;
                default:
                    this.currentView = 'HeadNav';
            }
            this.$store.dispatch('update_title', to.name);
        }
    }
};

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {



module.exports = __webpack_require__(154);

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {



module.exports = __webpack_require__(156);

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {



module.exports = __webpack_require__(158);

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {



module.exports = __webpack_require__(160);

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {



module.exports = __webpack_require__(162);

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {



module.exports = __webpack_require__(164);

/***/ }),
/* 154 */
/***/ (function(module, exports) {

module.exports = {
	name: 'foot-nav',
	data: function data() {
		return {};
	}
};

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(83);

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports = {
	name: 'head-nav',
	data: function data() {
		return {};
	},

	methods: {
		logout: function logout() {
			this.$store.dispatch('update_userinfo', {});
		}
	}
};

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(84);

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports = {
	name: 'head-nav',
	data: function data() {
		return {};
	},

	methods: {}
};

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(85);

/***/ }),
/* 160 */
/***/ (function(module, exports) {

module.exports = {
	name: 'home',
	data: function data() {
		return {
			data: {
				username: 'sls-1',
				password: '123456'
			}
		};
	},

	methods: {
		login: function login() {
			var _this = this;

			this.$$login(this.data, function (data) {
				_this.$store.dispatch('update_userinfo', data.userinfo);
			});
		}
	},
	mounted: function mounted() {}
};

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(86);

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports = {
	name: 'list',
	data: function data() {
		return {};
	}
};

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(87);

/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports = {
	name: 'view',
	data: function data() {
		return {};
	}
};

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(88);

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
	Home: __webpack_require__(161),
	List: __webpack_require__(163),
	View: __webpack_require__(165)
};

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
	Common: __webpack_require__(56),
	Modules: __webpack_require__(166)
};

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* harmony default export */ __webpack_exports__["a"] = {
	gbs: {
		host: '/rootApi',
		db_prefix: 'yourkey_',

		api_key: 'status',
		api_value: 200
	},

	cbs: {
		statusError: function statusError(err) {
			alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(err));
		},
		requestError: function requestError(err) {
			alert('请求错误');
		}
	}
};

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations_types__ = __webpack_require__(57);



/* harmony default export */ __webpack_exports__["a"] = {
	update_title: function update_title(_ref, title) {
		var commit = _ref.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			console.log('actions 接收title:' + title);
			commit(__WEBPACK_IMPORTED_MODULE_1__mutations_types__["a" /* UPDATE_TITLE */], title);
			resolve();
		});
	}
};

/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__state_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations_js__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters_js__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__getters_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_js__ = __webpack_require__(169);





/* harmony default export */ __webpack_exports__["a"] = {
	state: __WEBPACK_IMPORTED_MODULE_0__state_js___default.a,
	mutations: __WEBPACK_IMPORTED_MODULE_1__mutations_js__["a" /* default */],
	getters: __WEBPACK_IMPORTED_MODULE_2__getters_js___default.a,
	actions: __WEBPACK_IMPORTED_MODULE_3__actions_js__["a" /* default */]
};

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations_types__ = __webpack_require__(57);



/* harmony default export */ __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["a" /* UPDATE_TITLE */], function (state, title) {
	console.log('mutations 接收title:' + title);
	state.title = title;
});

/***/ }),
/* 173 */
/***/ (function(module, exports) {

module.exports = {
	title: '首页'
};

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations_types__ = __webpack_require__(58);



/* harmony default export */ __webpack_exports__["a"] = {
	update_userinfo: function update_userinfo(_ref, userinfo) {
		var commit = _ref.commit;

		return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
			console.log('actions 接收userinfo start');
			console.log(userinfo);
			console.log('actions 接收userinfo end');
			commit(__WEBPACK_IMPORTED_MODULE_1__mutations_types__["a" /* UPDATE_USERINFO */], userinfo);
			resolve();
		});
	}
};

/***/ }),
/* 175 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__state_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__state_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations_js__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters_js__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__getters_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_js__ = __webpack_require__(174);





/* harmony default export */ __webpack_exports__["a"] = {
	state: __WEBPACK_IMPORTED_MODULE_0__state_js___default.a,
	mutations: __WEBPACK_IMPORTED_MODULE_1__mutations_js__["a" /* default */],
	getters: __WEBPACK_IMPORTED_MODULE_2__getters_js___default.a,
	actions: __WEBPACK_IMPORTED_MODULE_3__actions_js__["a" /* default */]
};

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations_types__ = __webpack_require__(58);



/* harmony default export */ __webpack_exports__["a"] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1__mutations_types__["a" /* UPDATE_USERINFO */], function (state, userinfo) {
	console.log('mutations 接收userinfo start');
	console.log(userinfo);
	console.log('mutations 接收userinfo end');
	console.log(userinfo);
	state.userinfo = userinfo;
});

/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports = {
	userinfo: {}
};

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_request_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_router_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store___ = __webpack_require__(62);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
	el: '#app',
	router: __WEBPACK_IMPORTED_MODULE_3__config_router_js__["a" /* default */],
	store: __WEBPACK_IMPORTED_MODULE_4__store___["a" /* default */],
	template: '<App/>',
	components: {
		App: __WEBPACK_IMPORTED_MODULE_1__App___default.a
	}
});

/***/ })
]),[179]);


// WEBPACK FOOTER //
// static/js/app.d2272af2716a87ab48ef.js